(() => {
  function linkify(container) {
    if (!container) return;

    const map = [
      // Handle generic "here [LINK]" pointing to Privacy Policy (common phrasing)
      { label: 'here', url: window.location.origin + '/policies/privacy-policy', hereOnly: true },
      { label: 'Terms of Service', url: window.location.origin + '/policies/terms-of-service' },
      { label: 'Privacy Policy', url: window.location.origin + '/policies/privacy-policy' },
      { label: 'Refund Policy', url: window.location.origin + '/policies/refund-policy' },
      { label: 'Shipping Policy', url: window.location.origin + '/policies/shipping-policy' }
    ];

    const patterns = map.map(({ label, url, hereOnly }) => ({
      // "here [LINK]" or "Label [LINK]" (case-insensitive)
      regex: hereOnly
        ? /\bhere\s*\[\s*LINK\s*\]/gi
        : new RegExp(label.replace(/[-\/^$*+?.()|[\]{}]/g, '\\$&') + '\\s*\\[\\s*LINK\\s*\\]', 'gi'),
      label,
      url,
      hereOnly: !!hereOnly
    }));

    const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT, null);
    const toProcess = [];
    let node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue && /\[\s*LINK\s*\]/i.test(node.nodeValue)) {
        toProcess.push(node);
      }
    }

    for (const textNode of toProcess) {
      let text = textNode.nodeValue;
      let replaced = false;
      const frag = document.createDocumentFragment();

      // Process sequentially for each pattern
      let cursor = 0;
      while (true) {
        let earliest = null;
        let matchInfo = null;
        for (const p of patterns) {
          p.regex.lastIndex = cursor;
          const m = p.regex.exec(text);
          if (m && (!earliest || m.index < earliest.index)) {
            earliest = m;
            matchInfo = p;
          }
        }
        if (!earliest) break;
        if (earliest.index > cursor) {
          frag.appendChild(document.createTextNode(text.slice(cursor, earliest.index)));
        }
        const a = document.createElement('a');
        a.href = matchInfo.url;
        a.textContent = matchInfo.hereOnly ? 'here' : matchInfo.label;
        a.rel = 'noopener noreferrer';
        a.target = '_self';
        frag.appendChild(a);
        cursor = earliest.index + earliest[0].length;
        replaced = true;
      }

      if (replaced) {
        if (cursor < text.length) {
          frag.appendChild(document.createTextNode(text.slice(cursor)));
        }
        textNode.parentNode.replaceChild(frag, textNode);
      }
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const container = document.querySelector('.shopify-policy__container, .policy');
    linkify(container);
  });
})();


